import { Link } from 'react-router-dom';

const features = [
  { icon: 'ri-video-line', title: 'Video Lessons', desc: 'HD video content you can watch anytime, even on mobile data' },
  { icon: 'ri-quiz-line', title: 'Smart Quizzes', desc: 'Test your knowledge with instant feedback and explanations' },
  { icon: 'ri-bar-chart-fill', title: 'Progress Tracking', desc: 'Visual dashboards showing your learning journey step by step' },
  { icon: 'ri-award-line', title: 'Certificates', desc: 'Earn verifiable certificates that Nigerian employers recognise' },
];

export default function WhyLearnFlow({ content }) {
  const badgeText = content?.badgeText || 'Why LearnFlow Nigeria';
  const title = content?.title || 'Designed for the Nigerian Learner';
  const description = content?.description || 'We understand the Nigerian learning environment — from mobile data constraints to the fast-moving job market. LearnFlow combines structured learning paths, practical projects relevant to Nigerian industries, and smart assessments to give you the most effective experience. Join thousands of Nigerians who have transformed their careers.';
  const satisfactionRate = content?.satisfactionRate || '98% Satisfaction';
  const ratingScore = content?.ratingScore || '4.9/5 Rating';
  const featuresList = content?.features && content.features.length > 0 ? content.features : features;

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-teal-600 text-sm font-semibold uppercase tracking-widest mb-3">{badgeText}</p>
            <h2 className="text-4xl font-bold text-slate-900 leading-tight mb-5 whitespace-pre-line">
              {title}
            </h2>
            <p className="text-slate-500 leading-relaxed mb-8">
              {description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {featuresList.map(f => (
                <div key={f.title} className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-xl flex-shrink-0">
                    <i className={`${f.icon || 'ri-check-line'} text-teal-600 text-xl`} />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-slate-800">{f.title}</h4>
                    <p className="text-xs text-slate-500 mt-0.5 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/courses"
              className="inline-flex items-center gap-2 px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
            >
              Start Learning Today
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=young%20Nigerian%20African%20woman%20studying%20online%20on%20laptop%20at%20home%20comfortable%20modern%20setup%20natural%20window%20light%20warm%20bright%20productive%20study%20room%20Lagos%20apartment%20smiling%20focused&width=600&height=500&seq=ngwhy1&orientation=portrait"
              alt="Nigerian student learning online"
              className="w-full h-96 object-cover object-top rounded-2xl"
            />
            <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl p-4 border border-slate-100 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-emerald-50 rounded-xl">
                <i className="ri-check-double-line text-emerald-600 text-xl" />
              </div>
              <div>
                <p className="text-sm font-bold text-slate-900">{satisfactionRate}</p>
                <p className="text-xs text-slate-400">From 50,000+ learners</p>
              </div>
            </div>
            <div className="absolute -top-5 -right-5 bg-white rounded-2xl p-4 border border-slate-100">
              <div className="flex items-center gap-2 mb-1">
                {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-amber-400 text-xs" />)}
              </div>
              <p className="text-sm font-bold text-slate-900">{ratingScore}</p>
              <p className="text-xs text-slate-400">Verified Nigerian reviews</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
